import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverEntity } from '../../domain/entities/DriverEntity'
import type { AvailableDriverAdminDto } from '@/backend/market'
import type { UserEntity } from '@/features/user/domain/entities/UserEntity'
import type { RegionEntity } from '@/features/region/domain/entities/RegionEntity'

export class DriverModel extends DriverEntity {
  constructor(dataDto: AvailableDriverAdminDto, region?: RegionEntity, user?: UserEntity) {
    super()
    mapEntityProperties<DriverEntity>(this, dataDto, {
      map: {
        region: region,
        user: user
      }
    })
  }
}
